import { render, staticRenderFns } from "./HomeNew.vue?vue&type=template&id=a438be82&scoped=true"
import script from "./HomeNew.vue?vue&type=script&lang=js"
export * from "./HomeNew.vue?vue&type=script&lang=js"
import style0 from "./HomeNew.vue?vue&type=style&index=0&id=a438be82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a438be82",
  null
  
)

export default component.exports